import {
  ReeferIcon,
  DropTrailerIcon,
  DryVanIcon,
  FlatBedIcon,
  SpecializedDeprecatedIcon,
} from 'transfix-icons'
import { EQUIPMENT } from 'constants/equipment'

export enum EQUIPMENT_TYPE_NAME {
  OPEN_DECK = 'Open Deck',
  DRY_VAN = 'Dry Van',
  REEFER = 'Reefer',
  SPECIALIZED = 'Specialized',
}

export const findEquipmentIds = (equipmentKey: string) => {
  const equipmentElement = EQUIPMENT.find(element => element.key === equipmentKey)
  // eslint-disable-next-line camelcase
  return equipmentElement?.trailer_equipment_types
    .map(equipmentTypes => equipmentTypes.id)
    .concat(equipmentElement.id)
}

export const EQUIPMENT_ICON_MAP = [
  {
    ids: findEquipmentIds('dry_van'),
    key: 'dry_van',
    name: 'Dry Van',
    Icon: DryVanIcon,
  },
  {
    ids: findEquipmentIds('reefer'),
    key: 'reefer',
    name: 'Reefer',
    Icon: ReeferIcon,
  },
  {
    ids: findEquipmentIds('open_deck'),
    key: 'open_deck',
    name: 'Open Deck',
    Icon: FlatBedIcon,
  },
  {
    ids: findEquipmentIds('specialized'),
    key: 'specialized',
    name: 'Specialized',
    Icon: SpecializedDeprecatedIcon,
  },
  {
    ids: findEquipmentIds('drop_trailer'),
    key: 'drop_trailer',
    name: 'Drop Trailer',
    Icon: DropTrailerIcon,
  },
]

export const equipmentOptions = [
  {
    label: EQUIPMENT_TYPE_NAME.DRY_VAN,
    value: '3',
    selected: false,
  },
  {
    label: EQUIPMENT_TYPE_NAME.REEFER,
    value: '2',
    selected: false,
  },
  {
    label: EQUIPMENT_TYPE_NAME.OPEN_DECK,
    value: '1',
    selected: false,
  },
  {
    label: EQUIPMENT_TYPE_NAME.SPECIALIZED,
    value: '20',
    selected: false,
  },
]

export const CHILD_EQUIPMENT_TYPE_OPTIONS = [
  {
    name: "53' Van",
    id: 12,
  },
  {
    name: "53' Reefer",
    id: 8,
  },
  {
    name: "48' Flatbed",
    id: 5,
  },
]

export const convertEquipmentValueToName = (ids: string[]) =>
  equipmentOptions.filter(type => ids.includes(type.value)).map(type => type.label)
